<script lang="ts">
  import { beforeUpdate, onDestroy, onMount } from "svelte";
  import { cubicOut } from "svelte/easing";
  import { tweened } from "svelte/motion";
  import ProgressBar from "./ProgressBar.svelte";

  export let SymetricalElements = 1;
  export let activeElements = 1;
  export let timerval = 100;

  $: currentTime = 0;
  onMount(() => setInterval(() => currentTime < 100 && currentTime++, 1000));
  onDestroy(() => clearInterval(currentTime));
  $: stepWidth = Math.round(300 / timerval);

  const tweenedWidth = tweened(0, {
    duration: 400,
    easing: cubicOut,
  });
  $: tweenedWidth.set(currentTime * stepWidth);
</script>

{#key currentTime}
  <div class="time-container">
    <h5>time</h5>
    <div class="progress-bar" style=" width:{270 - $tweenedWidth}px; " />
  </div>
{/key}

<style>
  .time-container {
    display: flex;
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
  }
  .progress-bar {
    position: relative;
    display: flex;
    box-shadow: inset 2px 2px 5px 0px #000000;
    z-index: 100;
    height: 5px;
    width: 100%;
    overflow: hidden;
  }
</style>
